/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Typography } from "@mui/material";
import { useSubscribeToVideoViewing } from "../../hooks/events/useSubscribeToVideoViewing";
import { useEffect, useState } from "react";
import { useUserAuth } from "../../context/UserAuthContext";
import theme from "../../styles/styleTheme";
import { useTranslation } from "react-i18next";
import { useStages } from "../../hooks/tenants/useStages";
type VideoViewingProps = {
  propertyId: number;
  attendingToEventId: number;
};

const VideoViewing = ({
  propertyId,
  attendingToEventId,
}: VideoViewingProps) => {
  const { t } = useTranslation();
  const { user, reloadUserData } = useUserAuth();
  const [attendingVideoViewing, setAttendingVideoViewing] = useState(false);
  const { subscribeToVideoViewing } = useSubscribeToVideoViewing();
  const { getData: getStages, data: stages, getStageByName } = useStages();

  useEffect(() => {
    if (user) {
      getStages();
    }
  }, [user]);

  useEffect(() => {
    if (stages && user) {
      const videoViewingStageId = getStageByName("VideoViewing").id;
      setAttendingVideoViewing(
        user.tenant.candidatures.some(
          (candidature: any) =>
            candidature.propertyId === propertyId &&
            candidature.stageId === videoViewingStageId,
        ),
      );
    }
  }, [stages, user]);

  const handleSubscribeVideoViewing = async () => {
    setAttendingVideoViewing(true);
    await subscribeToVideoViewing(user.id, propertyId);
    reloadUserData();
  };

  const isAttendingEvent = attendingToEventId !== null;

  return (
    <>
      <Box marginTop={1}>
        <Divider
          sx={{
            marginBottom: 1,
            marginTop: 2,
            "&::before, &::after": {
              borderColor: "#b8b8b8",
            },
          }}
        >
          <Typography variant="body2">{t("viewing.video_viewing")}</Typography>
        </Divider>
        <Typography variant="body2" marginBottom={2}>
          {t("viewing.video_viewing.text")}
        </Typography>
        <Button
          sx={{
            padding: "1rem 0",
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.light,
            },
          }}
          onClick={handleSubscribeVideoViewing}
          fullWidth
          disabled={isAttendingEvent || attendingVideoViewing}
        >
          <Typography variant={"body2"}>
            {!isAttendingEvent && !attendingVideoViewing
              ? t("details.subscribe_video")
              : t("details.attending_video")}
          </Typography>
        </Button>
      </Box>
    </>
  );
};

export default VideoViewing;
